// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsSettingsUpdateBody = {
  poolId: string;
  maxSpotsPerMember: number | null;
};

export type typeStripsSettingsUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { maxSpotsPerMember?: number | null };
};

export type typeStripsSettingsUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsSettingsUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsSettingsUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsSettingsUpdateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    maxSpotsPerMember: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["poolId", "maxSpotsPerMember"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsSettingsUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsSettingsUpdateBody);
  }

  return async function postStripsSettingsUpdate(
    payload: typeStripsSettingsUpdateBody,
  ): Promise<
    typeStripsSettingsUpdateOutput200 | typeStripsSettingsUpdateOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsSettingsUpdate" failed before calling the network. #04b36b16eabc`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#04b36b16eabc" },
        },
        data: null,
      } as typeStripsSettingsUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/settings-update`,
      httpMethod: "POST",
      options,
    })) as
      typeStripsSettingsUpdateOutput200 | typeStripsSettingsUpdateOutput400;
  };
}
